import { useCurrentEditor, useEditorState } from "@tiptap/react";
import type { FC } from "react";

import { EditorButton, type EditorButtonProps } from "./editor-button";

export const EditorButtonUndo: FC<EditorButtonProps> = (props) => {
  const { editor } = useCurrentEditor();
  const editorState = useEditorState({
    editor,
    selector: (ctx) => ({
      canUndo: ctx.editor?.can().chain().undo().run() ?? false,
    }),
  });

  if (!editor || !editorState) {
    return null;
  }

  return (
    <EditorButton
      {...props}
      onClick={() => editor.chain().focus().undo().run()}
      disabled={!editorState.canUndo}
      icon="undo"
      tooltip="Undo"
    />
  );
};
